import { Component, OnInit } from '@angular/core';
import { Auth, signOut } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { SharedService } from '../../shared.service';

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss']
})
export class SidemenuComponent implements OnInit {
	config = {
		paddingAtStart: true,
		classname: "side-nav-menu",
		fontColor: "#000",
		selectedListFontColor: "#7366ff",
		highlightOnSelect: true,
		useDividers: false,
		collapseOnSelect: true,
	};

	appitems = [
		{
			label: "Management",
			icon: "inventory_2",
			items: [
				{
					label: "Organization",
					link: "/organization",
					icon: "remove"
				},
				{
					label: "Group",
					link: "/group",
					icon: "remove"
				},
				{
					label: "User",
					link: "/user",
					icon: "remove"
				}
			]
		},
		
		{
			label: "Countries",
			icon: "inventory_2",
			items: [
				{
					label: "Country",
					link: "/country",
					icon: "remove"
				},
				{
					label: "State",
					link: "/state",
					icon: "remove"
				},
				{
					label: "Region",
					link: "/region",
					icon: "remove"
				}
			]
		},
		{
			label: "Logout",
			link: "/",
			icon: "logout",
			onselect: this.onClickLogout()
		}
	];

	constructor(
		private auth: Auth,
		private router: Router,
		private sharedService: SharedService
	) {}

	ngOnInit() {}

	selectedItem(event:any) {
		this.router.navigate([event.link]);
	}

	async onClickLogout() {
		// localStorage.setItem('authToken', '');
		localStorage.setItem("userId", '');
		localStorage.setItem('groupId', '');
		localStorage.setItem('orgId', '');
		localStorage.setItem('firstName', '');
		localStorage.setItem('username', '');
		localStorage.setItem('userPic', '');
		localStorage.setItem('roleId', '');
		await signOut(this.auth);
		await this.router.navigate(["login"]);
	}
}
